import { request_detail, request_list, update_detail, create_detail, remove_detail, export_list } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource} from '@/commons/utils';
import Vue from 'vue';
var FileSaver = require('file-saver');
const endpoint = 'contact'
const viewTitle = 'Liên hệ'

// initial state
const state = {
    loading: false,
    all: [],
    reports:[],
    selected: {
        ID: 0,
        Status: 1
    }
};

// getters
const getters = {};

// actions
const actions = {
    exportList({ commit }, param) {
        export_list(endpoint, res => {
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"});
            FileSaver.saveAs(blob, `DanhSachLienHe_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export');
    },
    getReports({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint +  '/reports', data => {
            commit('setReports', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getList({ commit }, param) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_list(endpoint, data => {
                    commit('setList', data);
                    resolve(data);
                    commit("setLoading", { loading: false });
                }, Vue.http, param, this.state.authentication.token);
            }, 100)
        });
    },
    getDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        request_detail(endpoint, data => {
            commit('setDetail', data);
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    setDetail({ dispatch }, {param, data, id}) {
        if(id > 0) {
            update_detail(endpoint, res => {
                if(res.status == 202) {
                    sendErrorNotice(res.reason)                    
                }
                else if (res.data.status === 'fail') {
                    sendErrorNotice(`Không thể cập nhật ${viewTitle}.`);
                }
                else {
                    sendSuccessNotice(`Cập nhật ${viewTitle} thành công.`);
                    refreshResource();
                }                
            }, Vue.http, data, id, this.state.authentication.token);
        }
        else {
            delete data.ID;
            data.CreatedBy = this.state.authentication.user.username;
            create_detail(endpoint, res => {
                if(res.status == 202) {
                    sendErrorNotice(res.reason)                    
                }
                else if (res.data.status === 'fail') {
                    sendErrorNotice(`Không thể thêm mới ${viewTitle}.`)
                }
                else {
                    sendSuccessNotice(`Thêm mới ${viewTitle} thành công.`);
                    refreshResource();
                }
            }, Vue.http, data, this.state.authentication.token);
        }
    },
    removeDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice(`Không thể xóa ${viewTitle}.`)
            }
            else {
                sendSuccessNotice(`Đã xóa ${viewTitle} thành công.`)
                refreshResource();
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
};

// mutations
const mutations = {
    setList(state, data) {
        state.all = data;
    },
    setReports(state, data) {
        state.reports = data;
    },
    setDetail(state, item) {
        state.selected = item.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
